// extracted by mini-css-extract-plugin
export default {"custom":"styles_custom__BmALc","modalQuestionLocal":"styles_modalQuestionLocal__WyxSu","table":"styles_table__pM2f+","inputsRow":"styles_inputsRow__do-gI"};